import EmbedShell from './EmbedShell.vue'

export default [
  {
    path: '/embed/full-map',
    name: 'InTransitEmbedFullMap',
    component: EmbedShell,
    meta: { title: '全图可视组件', embedComponent: 'full-map', public: true }
  },
  {
    path: '/embed/waybill-map',
    name: 'InTransitEmbedWaybillMap',
    component: EmbedShell,
    meta: { title: '运单地图组件', embedComponent: 'waybill-map', public: true }
  },
  {
    path: '/embed/waybill-list',
    name: 'InTransitEmbedWaybillList',
    component: EmbedShell,
    meta: { title: '运单列表组件', embedComponent: 'waybill-list', public: true }
  }
]
